import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { StatusBadge } from "@/components/RemitKyc";

export const RemitAdminPanel = () => {
  const [kyc, setKyc] = useState([]);
  const [transfers, setTransfers] = useState([]);

  const load = () => {
    api.get("/remit/admin/kyc").then(({ data }) => setKyc(data)).catch(() => {});
    api.get("/remit/admin/transfers").then(({ data }) => setTransfers(data.slice(0, 30))).catch(() => {});
  };
  useEffect(load, []);

  const decide = async (u, status) => {
    const note = status === "rejected" ? window.prompt("Reason shown to the user (optional)") || "" : "";
    await api.put(`/remit/admin/kyc/${u.user_id}`, { status, note });
    toast.success(`KYC ${status}`); load();
  };
  const setStatus = async (t, status) => {
    await api.put(`/remit/admin/transfers/${t.id}`, { status, note: "manual" });
    toast.success(`Marked ${status}`); load();
  };

  const pending = kyc.filter((k) => k.status === "pending");
  return (
    <div className="space-y-4 mb-6" data-testid="remit-admin-panel">
      <div className="bg-white border border-black/10 rounded-2xl p-5 shadow-sm">
        <h2 className="font-heading font-bold mb-2">Identity checks {pending.length > 0 && <span className="ml-1 text-xs bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full">{pending.length} pending</span>}</h2>
        {kyc.length === 0 && <p className="text-sm text-zinc-400">No submissions yet.</p>}
        <div className="divide-y divide-black/5">
          {kyc.map((k) => (
            <div key={k.user_id} className="py-2 flex items-center justify-between gap-3 text-sm" data-testid={`kyc-row-${k.user_id}`}>
              <div className="min-w-0">
                <div className="font-semibold truncate">{k.legal_name} <span className="text-zinc-400 font-normal">· {k.email}</span></div>
                <div className="text-xs text-zinc-500 truncate">{k.id_type} {k.id_number} · DOB {k.dob} · {k.address}</div>
              </div>
              {k.status === "pending" ? (
                <div className="flex gap-2 shrink-0">
                  <button onClick={() => decide(k, "approved")} className="px-3 py-1 rounded-full bg-emerald-600 text-white text-xs font-bold" data-testid={`kyc-approve-${k.user_id}`}>Approve</button>
                  <button onClick={() => decide(k, "rejected")} className="px-3 py-1 rounded-full bg-zinc-100 text-zinc-700 text-xs font-bold" data-testid={`kyc-reject-${k.user_id}`}>Reject</button>
                </div>
              ) : <span className={`text-xs font-bold ${k.status === "approved" ? "text-emerald-700" : "text-red-600"}`}>{k.status}</span>}
            </div>
          ))}
        </div>
      </div>
      <div className="bg-white border border-black/10 rounded-2xl p-5 shadow-sm">
        <h2 className="font-heading font-bold mb-2">All transfers</h2>
        {transfers.length === 0 && <p className="text-sm text-zinc-400">None yet.</p>}
        <div className="divide-y divide-black/5">
          {transfers.map((t) => (
            <div key={t.id} className="py-2 flex items-center justify-between gap-3 text-sm" data-testid={`admin-transfer-${t.id}`}>
              <div className="min-w-0">
                <div className="font-semibold truncate">{t.flag} {t.recipient_name} · {t.symbol} {Number(t.receive_amount).toLocaleString()} <span className="text-zinc-400 font-normal">(${t.total_paid_usd.toFixed(2)} paid)</span></div>
                <div className="text-xs text-zinc-500">{t.reference} · {new Date(t.created_at).toLocaleString()} · {t.method}{t.provider_ref ? ` · ${t.provider_ref}` : ""}</div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <StatusBadge status={t.status} />
                {["processing", "paid", "payout_failed"].includes(t.status) && (
                  <select defaultValue="" onChange={(e) => e.target.value && setStatus(t, e.target.value)} className="text-xs border border-black/10 rounded-lg px-1 py-1" data-testid={`admin-transfer-action-${t.id}`}>
                    <option value="">Update…</option><option value="delivered">Delivered</option><option value="payout_failed">Payout failed</option><option value="refunded">Refunded</option>
                  </select>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
